export class CatalogSelection {
  constructor(collectedData) {
    this.collectedData = collectedData
  }
}

export class NewSessionSelection extends CatalogSelection {
}

export class ResumeSessionSelection extends CatalogSelection {
  sessionCode() { return this.collectedData.SessionCode }
}


export function promptUserWithCatalog({ organization, team, form ,formhero }) {
  let initCollectedData = {}

  return new Promise((resolve,reject) => {
      formhero.loadForm({
      organization, team, form,
      lang: 'en', // this form is built to be in English
      saveButtonMarkup: '<p></p>',   // save and exit button
      cancelButtonMarkup: '<p></p>', // alternate save and exit button ... you probably always want this blank
      // closeButtonMarkup: '<p></p>',  // thank you panel close button styling
      onStatusFn: function(status) {
        // path data is only available in status, and not in result
        // keep a pointer to last value to make available for compute on submit

        const { collectedData } = status

        if (collectedData.IsResumingPartialForm == "yes" && collectedData.SessionCode && collectedData.navigate) {
          formhero.closeOpenForms()
          resolve(new ResumeSessionSelection(collectedData))
          return
        }
        else if(collectedData.IsResumingPartialForm == "no" && collectedData.navigate){
           formhero.closeOpenForms()
          resolve(new NewSessionSelection(collectedData))
        }
      },
      onCloseFn: function() { console.log("The user closed the modal");}, // e.g. post thank you
    }, initCollectedData).then(
      function onsubmit(result) {
        reject(result)
      }
      // we don't define suspend, as we conceal suspend controls on this catalog call.
      // function onsuspend(suspendResult){}
    )
  })
}